import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
})
export class AdminHomeComponent implements OnInit {

  public appPages = [
    { title: 'Gestion des coachs', url: 'coachList', icon: 'mail' },
    { title: 'Gestion des formules', url: 'packages', icon: 'mail' },
    { title: 'Signaler un bug', url: 'reportBug', icon: 'bug' },
  ];

  constructor(
    private router: Router
  ) { }

  ngOnInit() { }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl("");
  }

}
